import { TaskStateTypes, TaskActionTypes } from "./Task.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: TaskStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchAllMod: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
  fetchSummaryReport: resetApiCallState({}),
};

const TaskReducer = (
  state: TaskStateTypes = INITIAL_STATE,
  action: any
): TaskStateTypes => {
  switch (action.type) {
    case TaskActionTypes.FETCH_ALL_TASK:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case TaskActionTypes.FETCH_ALL_TASK_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case TaskActionTypes.FETCH_ALL_TASK_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case TaskActionTypes.FETCH_ALL_TASK_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // -----

    case TaskActionTypes.FETCH_ALL_MOD_TASK:
      return {
        ...state,
        fetchAllMod: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case TaskActionTypes.FETCH_ALL_MOD_TASK_RESET:
      return {
        ...state,
        fetchAllMod: resetApiCallState([]),
      };
    case TaskActionTypes.FETCH_ALL_MOD_TASK_FAILURE:
      return {
        ...state,
        fetchAllMod: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case TaskActionTypes.FETCH_ALL_MOD_TASK_SUCCESS:
      return {
        ...state,
        fetchAllMod: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // -----

    case TaskActionTypes.FETCH_ONE_TASK:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case TaskActionTypes.FETCH_ONE_TASK_RESET:
      return {
        ...state,
        fetchOne: resetApiCallState({}),
      };
    case TaskActionTypes.FETCH_ONE_TASK_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case TaskActionTypes.FETCH_ONE_TASK_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    // -----

    case TaskActionTypes.FETCH_TASK_SUMMARY_REPORT:
      return {
        ...state,
        fetchSummaryReport: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case TaskActionTypes.FETCH_TASK_SUMMARY_REPORT_RESET:
      return {
        ...state,
        fetchSummaryReport: resetApiCallState({}),
      };
    case TaskActionTypes.FETCH_TASK_SUMMARY_REPORT_FAILURE:
      return {
        ...state,
        fetchSummaryReport: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case TaskActionTypes.FETCH_TASK_SUMMARY_REPORT_SUCCESS:
      return {
        ...state,
        fetchSummaryReport: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default TaskReducer;
